import { useState, useEffect } from "react";

const useNarrowMode = (threshold = 960) => {
  const [narrowMode, setNarrowMode] = useState(false);

  const isMobileDevice = () => {
    return /Mobi|Android/i.test(window.navigator.userAgent);
  };

  const isNarrowScreen = () => {
    return window.innerWidth <= threshold;
  };

  useEffect(() => {
    const updateNarrowMode = () => {
      setNarrowMode(isNarrowScreen() || isMobileDevice());
    };

    // Set initial value
    updateNarrowMode();

    // Add event listener for window resize
    window.addEventListener("resize", updateNarrowMode);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("resize", updateNarrowMode);
    };
  }, [threshold]);

  return narrowMode;
};

export default useNarrowMode;
